import { TimeZone } from './../data-access/src/lib/generated/generated';
import { DropdownItem } from '@tripointe/tripointe-cms/types';

export const TIME_ZONE_TO_LABEL_MAPPING = {
  [TimeZone.Pacific]: 'Pacific Time',
  [TimeZone.Mountain]: 'Mountain Time',
  [TimeZone.Central]: 'Central Time',
  [TimeZone.Eastern]: 'Eastern Time'
};

export const TIME_ZONE_OPTIONS: DropdownItem[] = [
  {
    text: TIME_ZONE_TO_LABEL_MAPPING[TimeZone.Pacific],
    value: TimeZone.Pacific
  },
  {
    text: TIME_ZONE_TO_LABEL_MAPPING[TimeZone.Mountain],
    value: TimeZone.Mountain
  },
  {
    text: TIME_ZONE_TO_LABEL_MAPPING[TimeZone.Central],
    value: TimeZone.Central
  },
  {
    text: TIME_ZONE_TO_LABEL_MAPPING[TimeZone.Eastern],
    value: TimeZone.Eastern
  }
];
